/* eslint-disable react/no-danger */
import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import { Button } from '@beef/ui-kit';
import { useIsMobileDimension } from "../../hooks/useGetDimensionGroup";
import style from "./styles.module.pcss";
import { InputItem } from "./Components/InputItem";
import { DEFAULT_ERROR } from "./consts";
import { useForm } from "./hooks/useForm";
var cn = classNames.bind(style);
export var Form = /*#__PURE__*/memo(function (_ref) {
  var form = _ref.form,
    className = _ref.className,
    onSubmitForm = _ref.onSubmitForm,
    _ref$isSuccessSending = _ref.isSuccessSending,
    isSuccessSending = _ref$isSuccessSending === void 0 ? false : _ref$isSuccessSending;
  var isMobile = useIsMobileDimension();
  var cells = form.cells,
    plaintext = form.plaintext,
    _form$button = form.button,
    text = _form$button.text,
    _form$button$variant = _form$button.variant,
    variant = _form$button$variant === void 0 ? 'secondary' : _form$button$variant,
    _form$theme = form.theme,
    theme = _form$theme === void 0 ? 'main' : _form$theme;
  var items = useMemo(function () {
    return cells.flat().map(function (cell) {
      return cell.items;
    }).flat();
  }, [cells]);
  var _useForm = useForm(items, onSubmitForm, isSuccessSending),
    errors = _useForm.errors,
    formState = _useForm.formState,
    handleSubmit = _useForm.handleSubmit,
    onChange = _useForm.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('form', "form--".concat(theme), className),
    "data-t-id": "components-Form"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('title', {
      withSubtitle: form.subtitle
    })
  }, form.title), form.subtitle && /*#__PURE__*/React.createElement("div", {
    className: cn('subtitle')
  }, form.subtitle), isMobile ? items.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('cell', {
        'cell--cb': item.type === 'checkbox'
      }),
      key: item.key
    }, /*#__PURE__*/React.createElement(InputItem, {
      error: errors.includes(item.key) ? item.errorMessage || item.placeholder || DEFAULT_ERROR : undefined,
      isSuccessSending: isSuccessSending,
      item: item,
      onChange: onChange,
      value: formState[item.key]
    }));
  }) : cells.map(function (cell, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('cell', {
        'cell--cb': cell.items.filter(function (item) {
          return item.type === 'checkbox';
        }).length
      }),
      key: index
    }, cell.items.map(function (item) {
      return /*#__PURE__*/React.createElement(InputItem, {
        error: errors.includes(item.key) ? item.errorMessage || item.placeholder || DEFAULT_ERROR : undefined,
        isSuccessSending: isSuccessSending,
        item: item,
        key: item.key,
        onChange: onChange,
        value: formState[item.key]
      });
    }));
  }), plaintext && /*#__PURE__*/React.createElement("div", {
    className: cn('plaintext')
  }, /*#__PURE__*/React.createElement("span", {
    className: cn('plaintext_text'),
    dangerouslySetInnerHTML: {
      __html: plaintext
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('button')
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubmit,
    variant: variant
  }, text)));
});
Form.displayName = Form.name;